import { FC } from "react";

const DropdownStatusColorMeaning: FC = (): JSX.Element => {
  return (
    <li className="nav-item dropdown">
      <button className="nav-link dropdown-toggle" type="button" data-bs-toggle="dropdown" data-bs-auto-close="outside" aria-expanded="false">
        Status Color Meaning 
      </button>

      <ul className="dropdown-menu dropdown-menu-end p-2 colors-dropdown">
        <p className="fs-6 p-1 lh-sm" aria-expanded="false">
          On the case screen, you can see the status of your case in real time. The status is also color-coded to make it easier to see what is happening at a glance:
        </p>

        <li>
          <hr className="dropdown-divider" />
        </li>

        <li className="d-flex align-items-center gap-2">
            <span className="btn background-color-1 rounded-0 my-1 text-white h-100">
                &nbsp;
            </span>
          <p className="p-1 mb-0 lh-sm">
            The initial color for a case, indicating it is pending
            investigation and no action is currently required.
          </p>
        </li>

        <li>
          <hr className="dropdown-divider" />
        </li>

        <li className="d-flex align-items-center gap-2">
          <span className="btn background-color-5 rounded-0 my-1 text-white h-100">
            &nbsp;
          </span>
          <p className="lh-sm p-1 mb-0">
            Some action or documentation is required by you, such as providing
            clinical documentation for precertification.
          </p>
        </li>

        <li>
          <hr className="dropdown-divider" />
        </li>

        <li className="d-flex align-items-center gap-2">
          <span className="btn background-color-2 rounded-0 my-1 h-100">
            &nbsp;
          </span>
          <p className="lh-sm p-1 mb-0">
            Benefits investigation is complete and no further actions
            are required.
          </p>
        </li>

        <li>
          <hr className="dropdown-divider" />
        </li>

        <li className="d-flex align-items-center gap-2">
          <span className="btn background-color-3 rounded-0 my-1 h-75">
            &nbsp;
          </span>
          <p className="lh-sm p-1 mb-0">
            A treatment decision has been indicated by you, such as Transferring
            the prescription or pulling medication from stock.
          </p>
        </li>

        <li>
          <hr className="dropdown-divider" />
        </li>

        <li className="d-flex align-items-center gap-2">
          <span className="btn background-color-4 rounded-0 my-1 h-100">
            &nbsp;
          </span>
          <p className="lh-sm p-1 mb-0">
            The request has been cancelled. Please review the
            case notes for further details.
          </p>
        </li>
      </ul>
    </li>
    // <div className="p-2 overflow-auto">
    //   <p>
    //     On the case screen, you can see the status of your case in real time. The status is also color-coded to make it easier to see what is happening at a glance:
    //   </p>
    //   <div className="dropdown-divider"></div>

    //   {/* Pending Investigation */}
    //   <div className="row">
    //     <div className="col-sm-1 pl-2">
    //       <span className="btn background-color-1 my-1 text-white">&nbsp;</span>
    //     </div>
    //     <div className="col-sm-11">
    //       The initial color for a case, indicating it is pending investigation and no action is currently required.
    //     </div>
    //   </div>
    //   <div className="dropdown-divider"></div>

    //   {/* Action Required */}
    //   <div className="row">
    //     <div className="col-sm-1 pl-2">
    //       <span className="btn background-color-5 my-1 text-white">&nbsp;</span>
    //     </div>
    //     <div className="col-sm-11">
    //       Some action or documentation is required by you, such as providing clinical documentation for precertification.
    //     </div>
    //   </div>
    //   <div className="dropdown-divider"></div>

    //   {/* Investigation Complete */}
    //   <div className="row">
    //     <div className="col-sm-1 pl-2">
    //       <span className="btn background-color-2 my-1 text-white">&nbsp;</span>
    //     </div>
    //     <div className="col-sm-11">
    //       Benefits investigation is complete and no further actions are required.
    //     </div>
    //   </div>
    //   <div className="dropdown-divider"></div>

    //   {/* Treatment Decision */}
    //   <div className="row">
    //     <div className="col-sm-1 pl-2">
    //       <span className="btn background-color-3 my-1 text-white">&nbsp;</span>
    //     </div>
    //     <div className="col-sm-11 pl-2">
    //       A treatment decision has been indicated by you, such as Transferring the prescription or pulling medication from stock.
    //     </div>
    //   </div>
    //   <div className="dropdown-divider"></div>

    //   {/* Cancelled */}
    //   <div className="row">
    //     <div className="col-sm-1 pl-2">
    //       <span className="btn background-color-4 my-1 text-white">&nbsp;</span>
    //     </div>
    //     <div className="col-sm-11">
    //       The request has been cancelled. Please review the case notes for further details.
    //     </div>
    //   </div>
    // </div>
  );
};

export default DropdownStatusColorMeaning;
